// @flow
import { styled } from 'mz-ui-kit'
import CheckIcon from 'mz-icons/check'
import { getAppearanceFunc } from '../../utils'
import * as primary from './appearance/primary'
import * as inverse from './appearance/inverse'
import type { BaseStyles } from '.'

// Constants
const BASE_CLASS = 'checkbox'
const APPEARANCES = {
  primary,
  inverse,
  'primary-inverse': inverse, // DEPRECATED
}

const createAppearanceFunc = getAppearanceFunc(APPEARANCES, 'primary')

export const Label = styled<BaseStyles>(
  {
    base: 'label',
    mozClassName: ({ $appearance }) => [
      BASE_CLASS,
      `${BASE_CLASS}--${$appearance}`,
    ],
  },
  createAppearanceFunc('Label')
)

export const Input = styled<BaseStyles>(
  {
    base: 'input',
    mozClassName: `${BASE_CLASS}__input`,
  },
  createAppearanceFunc('Input')
)

export const CheckContainer = styled<BaseStyles>(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__check-container`,
  },
  createAppearanceFunc('CheckContainer')
)

export const CheckMark = styled<BaseStyles>(
  {
    base: CheckIcon,
    mozClassName: `${BASE_CLASS}__check-mark`,
  },
  createAppearanceFunc('CheckMark')
)

export const RadioMark = styled<BaseStyles>(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__radio-mark`,
  },
  createAppearanceFunc('RadioMark')
)
